module.exports = __webpack_public_path__ + "img/carousel-arrow-next.1fcda3e2.png";